import React, { useEffect, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import { useQuery } from "@apollo/client";
import { GET_MEMBER_DETAILS } from "../graphql/queries";
import ReceiptPreview from "./ReceiptPreview";
import NotLoggedIn from "../components/LoginExceptions";


const PaymentReceipt = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const storedUserType = localStorage.getItem("user_type");





  useEffect(() => {
    const storedMobile = localStorage.getItem("mobile");
    if (storedMobile) setMobile(storedMobile);
  }, []);



  const { loading, error, data } = useQuery(GET_MEMBER_DETAILS, {
    variables: { mobile },
    skip: !mobile,
  });
  if (!storedUserType) {
    return <NotLoggedIn />;
  }
  if (loading)
    return (
      <div className="min-h-screen flex flex-col">
        <div className="flex-grow flex justify-center items-center">
          <p className="text-gray-600">Loading...</p>
        </div>
        <footer className="bg-gray-200 text-center py-4 text-sm text-gray-600">
          © 2025 Your Organization. All rights reserved.
        </footer>
      </div>
    );

  if (error)
    return (
      <div className="min-h-screen flex flex-col">
        <div className="flex-grow flex justify-center items-center">
          <p className="text-red-600">Error loading member details.</p>
        </div>
        <footer className="bg-gray-200 text-center py-4 text-sm text-gray-600">
          © 2025 Your Organization. All rights reserved.
        </footer>
      </div>
    );

  if (!data?.member)
    return (
      <div className="min-h-screen flex flex-col">
        <div className="flex-grow flex justify-center items-center">
          <p className="text-gray-600">No member data available.</p>
        </div>
        <footer className="bg-gray-200 text-center py-4 text-sm text-gray-600">
          © 2025 Your Organization. All rights reserved.
        </footer>
      </div>
    );

  const member = data.member;

  const isPaymentPaid = member.Payment_Status === "Paid";


  const downloadPdf = () => {
    const input = document.getElementById("receipt");
    html2canvas(input, {
      scale: 3,
      useCORS: true,
      scrollX: 0,
      scrollY: 0,
      width: input.scrollWidth,
      height: input.scrollHeight,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png", 1.0);
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const pageHeight = 297;
      let imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (imgHeight > pageHeight) {
        let heightLeft = imgHeight;
        let position = 0;

        while (heightLeft > 0) {
          pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
          if (heightLeft > 0) {
            pdf.addPage();
            position = -pageHeight;
          }
        }
      } else {
        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      }

      pdf.save("payment_receipt.pdf");
    });
  };

  return (
    <div className="max-w-4xl w-full mx-auto border p-6 shadow-lg min-h-[500px] flex flex-col items-center justify-center bg-gray-50">
      {!isPaymentPaid ? (
        <Typography variant="body1" color="#7A7841" textAlign="center">
          To view or download the receipt, please complete your pending payment.{" "}
          <Typography
            component="span"
            sx={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
            onClick={() => {
              navigate("/paymentgateway");
              window.scrollTo(0, 0);
            }}
          >
            Click here
          </Typography>{" "}
          to proceed to the payment process. Once the payment is successful, the receipt will be available.
        </Typography>
      ) : (
        <>
          <ReceiptPreview member={member} />

          <div className="flex justify-center mt-6">
          <button
            onClick={downloadPdf}
            style={{ backgroundColor: '#2A289C' }}
            className="text-white px-4 py-2 rounded "
          >
            Download Receipt
          </button>
        </div>
        </>
      )}
    </div>
  );
};

export default PaymentReceipt;
